import axios from 'axios';
import config from 'src/config/app';

// This goes to the persona api endpoint in our system and returns
// information about the user. The request is validated using the
// _pagerduty_session cookie that gets sent along in the network request
// @returns a data object with traits
//

const getPersonaData = async params => axios({
  method: 'GET',
  baseURL: config.BASE_PATH,
  url: 'api/personas/persona',
  params
});

export default getPersonaData;
